<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useStore } from '../../../../store/index'
import { ref } from 'vue'

const { t } = useI18n()
const store = useStore()
const trackingDomain = store.trackingDomain

const orientation = ref(store.urlParameters?.orientation.split('-')[0])

function clickButton() {
  window.location.href = `https://${trackingDomain}/click`
}
</script>

<template>
  <div class="flex flex-col items-center w-full space-y-5 text-center mt-7">
    <h1
      class="text-[#626c72] text-2xl font-normal tracking-[0.2rem] md:font-semibold uppercase"
    >
      {{ t(`noEmail.${orientation}.text1`) }}
    </h1>
    <h2 class="text-[#677277] tracking-[0.2rem] uppercase">
      {{ t(`noEmail.${orientation}.text2`) }}
    </h2>
    <button
      class="border border-[#cbcfd2] py-2 px-6 rounded-md text-sm hover:border-red-400 hover:text-red-400 duration-200 uppercase font-bold flex flex-row justify-center items-center"
      @click="clickButton"
    >
      {{ t(`noEmail.${orientation}.button`) }}
    </button>
  </div>
</template>
